import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { offsetLimitPagination } from "@apollo/client/utilities"
import { setContext } from '@apollo/client/link/context';
import { BASE_API_URL } from "./ApiUrls";

export default function configureGraphQL(store) {
    const httpLink = createHttpLink({
        uri: `${BASE_API_URL}graphql`,
    });

    const authLink = setContext((_, { headers }) => {
        // get the authentication token from local storage if it exists
        const token = (store.getState().login.auth || {}).token;
        // return the headers to the context so httpLink can read them
        return {
            headers: {
                ...headers,
                authorization: token ? `Bearer ${token}` : "",
            }
        }
    });

    //function pagedListPagination(keyArgs) {
    //    return {
    //        keyArgs: [],
    //        merge: (existing = {items = []}, incoming) => {
    //            const { items, ...rest } = incoming;
    //            let data = { ...existing, ...rest };
    //            data.items = [...data.items, ...items];
    //        },
    //        read: (existing, { args: { page = 1, pageSize = 10 } } = {}) => {
    //            const offset = (page - 1) * pageSize;
    //            const { items, ...rest } = existing;
    //            let data = { ...existing, ...rest };
    //            return existing && existing.slice(offset, offset + pageSize);
    //        }
    //    }
    //}

    const cache = new InMemoryCache();

    const client = new ApolloClient({
        link: authLink.concat(httpLink),
        cache: cache
    });

    return client;
}


// WEBPACK FOOTER //
// ./src/common/configureGraphQL.js